import { useEffect } from 'react';

export const formatPrescriptionIdentifier = (identifier: string) =>
	identifier
		.match(/.{1,4}/g)
		?.join(' ')
		.toUpperCase();

export function useEffectAsync(op: any, deps: any = []) {
	useEffect(() => {
		try {
			new Promise(resolve => {
				op().then((result: unknown) => {
					resolve(result);
				});
			}).then();
		} catch (e) {
			console.log({e});
		}
	}, deps ?? []);
}
